import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const Root = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'positionType',
})<{ positionType?: 'default' | 'absoluteCenter' }>(({ positionType }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  ...(positionType === 'absoluteCenter' && {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  }),
}));

export const Text = styled(Typography)(() => ({
  fontSize: '10px',
  fontWeight: 700,
  textTransform: 'uppercase',
}));
